var ezdia;
(function (ezdia) {
    var SearchList = /** @class */ (function () {
        function SearchList(elem, options) {
            var _this = this;
            this.$elem = $(elem);
            this.options = options;
            this.$container = $(this.options.container);
            this.$lists = this.$container.find(this.options.items);
            if (this.options.emptyShow) {
                this.createEmptyMsg();
            }
            this.$elem.on(this.options.trigger, function () {
                _this.searchText();
            });
        }
        SearchList.prototype.searchText = function () {
            var self = this;
            var query = this.$elem.val();
            query = query.toLowerCase();
            this.$lists.each(function each() {
                var element = $(this);
                var text = getValue.call(self, element);
                if (text.includes(query)) {
                    element.show();
                }
                else {
                    element.hide();
                }
            });
            if (this.options.emptyShow) {
                this.displayEmptyMsg();
            }
        };
        SearchList.prototype.createEmptyMsg = function () {
            var _a = this.options, emptyId = _a.emptyId, emptyCls = _a.emptyCls, emptyQueryMsg = _a.emptyQueryMsg, container = _a.container;
            var element = this.$container.find("#" + emptyId);
            if (!element.length) {
                this.$container.append($('<li>', {
                    id: emptyId,
                    class: emptyCls,
                    text: emptyQueryMsg,
                    css: { display: 'none' }
                }));
                this.$container = $(container);
                this.$emptyId = this.$container.find("#" + emptyId);
            }
            else if (!this.$emptyId) {
                this.$emptyId = this.$container.find("#" + emptyId);
            }
        };
        SearchList.prototype.displayEmptyMsg = function () {
            if (this.$lists.is(':visible')) {
                this.$emptyId.hide();
            }
            else {
                this.$emptyId.show();
            }
        };
        return SearchList;
    }());
    function getValue(element) {
        var options = this.options;
        var val = '';
        var elem = $(element);
        if (options.child) {
            elem = $(elem).find(options.child);
        }
        val = elem.text() || '';
        return val.toLowerCase().trim();
    }
    $.fn.filterSearch = function filterSearch(options) {
        // eslint-disable-next-line consistent-return
        return this.each(function each() {
            var self = $(this);
            $.fn.filterSearch.options.container = "[data-search-container=\"" + self.attr('id') + "\"]";
            if (options && typeof options === 'string') {
                return new Error('Invalid option');
            }
            self.data('searchList', new SearchList(this, $.extend({}, $.fn.filterSearch.options, options)));
        });
    };
    $.fn.filterSearch.options = {
        container: '',
        items: '> li',
        trigger: 'keyup',
        emptyShow: true,
        emptyId: 'noresult',
        emptyQueryMsg: 'Search query not found.',
        emptyCls: 'warning',
        child: ''
    };
})(ezdia || (ezdia = {}));
